module.exports = __webpack_public_path__ + "static/img/23_daddy.b3e58ac5.jpg";